import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import { IoIosApps, IoMdCheckmark, IoMdClose } from "react-icons/io";
class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dependencies: {}
        };
    }

    componentDidMount() {
        this.checkStatus();
    }

    checkStatus = async () => {
        console.log('checking the dependencies are correct in environment: ', process.env.NODE_ENV);
        const response = await fetch('/status').catch(err => {
            console.info('error getting status', err);
        });

        const dependencies = await response.json();

        console.log('dependencies-->', dependencies);

        this.setState({
            dependencies
        });

        setTimeout(() => {
            console.info('allWidgetsRendered');
        }, 1000);
    }

    sendMail = async () => {
        const { email } = this.state;
        this.setState({
            isSendingEmail: true
        });

        await fetch('/test-email', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                emailTo: email.trim(),
            })
        }).catch(err => {
            console.info('error getting test-pdf', err);
        });

        this.setState({
            isSendingEmail: false
        });
    }

    doDownload = async () => {
        this.setState({
            isDownloading: true
        });

        const response = await fetch('/test-pdf').catch(err => {
            console.info('error getting test-pdf', err);
        });

        this.setState({
            isDownloading: false
        });

        if (response) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `test@${Date.now()}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }

    render() {
        const {
            isDownloading,
            isSendingEmail,
        } = this.state;
        const {
            nodeId,
            status,
            version,
            config,
            dependencies: {
                database,
                eventsPublisher,
                publisherLoopBack: {
                    confirmed
                } = {}
            } = {}
        } = this.state.dependencies;

        const loopBackStatus = confirmed ? 'connected' : 'n/a';
        const isRunning = /running/.test(status);
        const StatusIcon = (val) => {
            return (/connected/i).test(val) ? <IoMdCheckmark className={'io-icon running'} size={20} /> : <IoMdClose className={'io-icon not-running'} size={20} />;
        }

        return (
            <div className="App">
                {/*<header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>*/}

                <div className={'title'}>
                    <IoIosApps size={25} className={`io-icon ${isRunning ? 'running' : 'not-running'}`} /> Export Service
                </div>

                <br />
                <br />

                <div className={'label-container section-title'}>
                    Status
                </div>
                <div className={'label-container status-label info'}>
                    This section shows service dependencies status
                </div>
                <hr />

                <div className={'label-container status-label'}>
                    Version: {version}
                </div>

                <div className={'label-container status-label'}>
                    Config: {config}
                </div>

                <div className={'label-container status-label'}>
                    Database: {StatusIcon(database)}
                </div>

                <div className={'label-container status-label'}>
                    Event Publisher: {StatusIcon(eventsPublisher)}
                </div>

                <div className={'label-container status-label'}>
                    Publisher Loopback: {StatusIcon(loopBackStatus)}
                </div>


                <br />

                <div className={'label-container section-title'}>
                    Language Support
                </div>
                <div className={'label-container status-label info'}>
                    This section shows how pdf service renders non-Latin characters
                </div>
                <hr />

                <textarea
                    defaultValue={'组织绩效 总销售额 对比上年度 销售额 顾客人数 对比上年度 平均成交率 对比上年度 平均每单交易金额 对比上年度 平均员工工时比 对比上年度'}
                    className={'label-container status-label label-small text-area-container text-area'}
                />


                <br />
                <div className={'label-container section-title'}>
                    Test PDF
                </div>
                <div className={'label-container status-label info'}>
                    PDF generation, upload and download e2e test
                </div>
                <hr />
                <div className={'label-container section-title download'}>
                    <button
                        type="button"
                        disabled={isDownloading}
                        onClick={this.doDownload}>{isDownloading ? 'Downloading...' : 'Download'}</button>
                </div>

                <br />
                <div className={'label-container section-title'}>
                    Test Email
                </div>
                <div className={'label-container status-label info'}>
                    Email template and notification. Type in your email and hit send
                </div>
                <hr />

                <textarea
                    placeholder={'Email address'}
                    onChange={e => this.setState({
                        email: e.target.value
                    })}
                    className={'label-container status-label label-small text-input-container text-input'}
                />

                <div className={'label-container section-title download'}>
                    <button
                        type="button"
                        disabled={isSendingEmail}
                        onClick={this.sendMail}>{isSendingEmail ? 'Sending...' : 'Send'}</button>
                </div>


                <br />
                <div className={'label-container status-label label-small'}>
                    {nodeId}
                </div>


            </div>
        );
    }
}

export default App;
